import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000,
});

export default axiosInstance;
